export default "__VITE_ASSET__BuAC5RMs__"